import React from 'react';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import MDICheckCircle from 'src/assets/images/MDICheckCircle.svg';
import {
    Row,
    Icon,
    Status,
    RegularSmallText,
} from 'src/pages/orders/components/reportsAndInvoice/sendUsageReport/SendUsageReport.styled';
import { TextBold } from 'src/common/components/filter/Filters.styled.jsx';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

const ReportsFooter = (props) => {
    const { t } = useTranslation();
    return (
        <>
            {props.isMobile ? (
                props.isSent ? (
                    <ShadowContainer>
                        <Icon 
                        id="reports-footer-icon"
                        src={MDICheckCircle}></Icon>
                        <Status>
                            <RegularSmallText fontSize={'16px'}>
                                {t(
                                    'orders.reportsAndInvoice.requestInvoice.sentSuccessfully1'
                                )}
                            </RegularSmallText>
                        </Status>
                    </ShadowContainer>
                ) : (
                    <>
                <Button
                id={'orders-reportsandinvoice-reportfooter-viewreport'}
                

                            show
                            //secondary={!props.disabled}
                            width="148px"
                            height="38px"
                            margin="0 5px 0 0"
                            border={'1px solid #140F4B'}
                            clicked={props.viewReportHandler}
                            disabled={props.disabled}
                            variant={props.disabled ? ButtonStyles?.disabled : ButtonStyles?.secondary}
                        >
                            <TextBold
                                color={props.disabled ? '#FFFF' : '#140F4B'}
                            >
                                {t(
                                    'orders.reportsAndInvoice.reportsFooter.viewReport'
                                )}
                            </TextBold>
                        </Button>
                        <Button
                        id={'orders-reportsandinvoice-reportfooter-sending'}
                       
                            show
                            //primary={!props.disabled}
                            width="148px"
                            height="38px"
                            margin="0 0 0 5px"
                            clicked={props.onSendUsageReport}
                            disabled={props.disabled}
                            //secondary
                            variant={props.disabled ? ButtonStyles?.disabled : ButtonStyles?.primary}
                        >
                            <TextBold color={'#FFFF'}>
                                {props.loading
                                    ? t(
                                          'orders.reportsAndInvoice.reportsFooter.sending'
                                      )
                                    : t(
                                          'orders.reportsAndInvoice.reportsFooter.sendreport'
                                      )}
                            </TextBold>
                        </Button>
                    </>
                )
            ) : (
                <BottomNavigation
                    justifyContent="flex-end"
                    moblieJustifyContent="center"
                    padding="11px 20px"
                >
                    {props.isSent ? (
                        <>
                            <Row>
                                <Icon 
                                id="reports-footer-icon"
                                src={MDICheckCircle}></Icon>
                                <Status>
                                    <RegularSmallText fontSize={'16px'}>
                                        {t(
                                            'orders.reportsAndInvoice.reportsFooter.sentmsg2'
                                        )}
                                    </RegularSmallText>
                                </Status>
                            </Row>
                        </>
                    ) : (
                        <>
                            <Button
                            id={'orders-reportsandinvoice-reportfooter-viewreportbutton'}
                           
                                show
                                //secondary={!props.disabled}
                                width="148px"
                                height="38px"
                                margin="0 5px"
                                clicked={props.viewReportHandler}
                                disabled={props.disabled}
                                variant={props.disabled ? ButtonStyles?.disabled : ButtonStyles?.secondary}
                            >
                                <TextBold
                                    color={props.disabled ? '#FFFF' : '#1010EB'}
                                >
                                    {t(
                                        'orders.reportsAndInvoice.reportsFooter.viewReport'
                                    )}
                                </TextBold>
                            </Button>
                            <Button
                            id={'orders-reportsandinvoice-reportfooter-sendreport'}
                               
                                show
                                //primary={!props.disabled}
                                width="148px"
                                height="38px"
                                margin="0 5px"
                                clicked={props.onSendUsageReport}
                                disabled={props.disabled}
                                variant={props.disabled ? ButtonStyles?.disabled : ButtonStyles?.primary}
                            >
                                <TextBold color={'#FFFF'}>
                                    {props.loading
                                        ? 'Sending...'
                                        : 'Send Report'}
                                </TextBold>
                            </Button>
                        </>
                    )}
                </BottomNavigation>
            )}
        </>
    );
};

export default ReportsFooter;

const ShadowContainer = styled.div`
    background: #ffffff;
    /* box-shadow: 0px -3px 6px #00000014; */
    border-radius: 0px 0px 6px 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0px;
    width: 100%;
`;
